//imports
import React from "react"

//Projects page Component
function ProjectsPage(props) {
            return (
                <p className = "projects-text">Coming soon!</p>
                    )

}


export default ProjectsPage